import React from 'react';
import { motion } from 'framer-motion';
import { Star, Apple } from 'lucide-react';
export function CTASection() {
  return <section className="py-24 relative overflow-hidden" data-id="element-8">
      {/* Background with gradient overlay */}
      <div className="absolute inset-0 bg-gaming-dark" data-id="element-9">
        <div className="absolute inset-0 bg-gradient-to-r from-gaming-purple/20 to-gaming-cyan/20" data-id="element-10"></div>
        <div className="absolute inset-0 bg-[url('https://www.transparenttextures.com/patterns/carbon-fibre.png')] opacity-20" data-id="element-11"></div>
      </div>

      <div className="container mx-auto px-4 relative z-10 max-w-5xl" data-id="element-12">
        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="bg-gaming-card/80 backdrop-blur-lg border border-white/10 rounded-2xl p-8 md:p-16 text-center shadow-2xl relative overflow-hidden" data-id="element-13">
          {/* Animated Glow Effect */}
          <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-transparent via-gaming-cyan to-transparent animate-pulse" data-id="element-14"></div>

          <div className="flex justify-center mb-6" data-id="element-15">
            <div className="flex gap-1" data-id="element-16">
              {[1, 2, 3, 4, 5].map(star => <Star key={star} className="w-6 h-6 text-yellow-400 fill-yellow-400" data-id="element-17" />)}
            </div>
          </div>

          <h2 className="text-4xl md:text-6xl font-black text-white mb-6 uppercase tracking-wider" data-id="element-18">
            ¿Listo para{' '}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-gaming-cyan to-gaming-purple" data-id="element-19">
              Subir de Nivel?
            </span>
          </h2>

          <p className="text-xl text-gray-300 mb-10 max-w-2xl mx-auto" data-id="element-20">
            Únete a miles de jugadores ecuatorianos que ya están recibiendo
            beneficios por hacer lo que más les gusta.
          </p>

          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center" data-id="element-21">
            <motion.a href="https://apps.apple.com/app/levelup-play" target="_blank" rel="noopener noreferrer" whileHover={{
            scale: 1.05
          }} whileTap={{
            scale: 0.95
          }} className="px-8 py-4 bg-black text-white font-bold text-lg rounded-xl shadow-[0_0_30px_rgba(0,0,0,0.4)] hover:shadow-[0_0_50px_rgba(0,0,0,0.6)] transition-all flex items-center justify-center gap-3 min-w-[200px]" data-id="element-22">
              <Apple className="w-7 h-7" data-id="element-23" />
              <div className="text-left" data-id="element-24">
                <div className="text-xs opacity-80" data-id="element-25">Descargar en</div>
                <div className="text-base font-bold" data-id="element-26">App Store</div>
              </div>
            </motion.a>

            <motion.a href="https://play.google.com/store/apps/details?id=com.levelupplay" target="_blank" rel="noopener noreferrer" whileHover={{
            scale: 1.05
          }} whileTap={{
            scale: 0.95
          }} className="px-8 py-4 bg-black text-white font-bold text-lg rounded-xl shadow-[0_0_30px_rgba(0,0,0,0.4)] hover:shadow-[0_0_50px_rgba(0,0,0,0.6)] transition-all flex items-center justify-center gap-3 min-w-[200px]" data-id="element-27">
              <svg className="w-7 h-7" viewBox="0 0 24 24" fill="currentColor" data-id="element-28">
                <path d="M3,20.5V3.5C3,2.91 3.34,2.39 3.84,2.15L13.69,12L3.84,21.85C3.34,21.6 3,21.09 3,20.5M16.81,15.12L6.05,21.34L14.54,12.85L16.81,15.12M20.16,10.81C20.5,11.08 20.75,11.5 20.75,12C20.75,12.5 20.53,12.9 20.18,13.18L17.89,14.5L15.39,12L17.89,9.5L20.16,10.81M6.05,2.66L16.81,8.88L14.54,11.15L6.05,2.66Z" data-id="element-29" />
              </svg>
              <div className="text-left" data-id="element-30">
                <div className="text-xs opacity-80" data-id="element-31">Disponible en</div>
                <div className="text-base font-bold" data-id="element-32">Google Play</div>
              </div>
            </motion.a>
          </div>

          <p className="mt-6 text-sm text-gray-500" data-id="element-33">Gratis para siempre</p>
        </motion.div>
      </div>
    </section>;
}